// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FullA_TheComp__HrbKf"};